// BHPNPP-3357: the Contact Management funnel, which holds the search too.

import {EnumToMapping} from '../../../../common/domain/types';
import {splitAndRemoveEmpty} from '../../../../placement/const';

export enum BusinessContactStatus {
    Active = 'Active',
    Inactive = 'Inactive',
}

/** The funnel's Status options. The empty value reads "All Status" and sends no status at all. */
export const {
    nameToValueWithDefault: BusinessContactStatusMapWithDefault,
} = EnumToMapping(BusinessContactStatus, {value: '', label: 'All Status'});

/**
 * What the funnel holds. search is the text as typed; it matches Name, Title, Email and Phone on the
 * backend. businessFunction is DropdownMultiSelect's own shape: the picked values joined by
 * SPLIT_DELIMITER ('; '). It becomes a list only on the way to the backend.
 */
export type BusinessContactFilterValue = {
    search: string;
    businessFunction: string;
    status: string;
};

export const EMPTY_FILTER: BusinessContactFilterValue = {search: '', businessFunction: '', status: ''};

/** True when the search holds more than spaces. Spaces alone search nothing and earn no chip. */
export const hasSearch = (filter: BusinessContactFilterValue): boolean => filter.search.trim() !== '';

export type BusinessContactFilterParams = {
    search: string | null;
    businessFunctions: string[] | null;
    status: string | null;
};

/**
 * The funnel's values as the query sends them. The picks have to travel as a list: sent as the joined
 * string, GraphQL would wrap it in a one-item list and the backend would look for a function named
 * "Billing; Intake", so the grid would come back empty with no error.
 */
export const asQueryParam = (filter: BusinessContactFilterValue): BusinessContactFilterParams => {
    const picks = splitAndRemoveEmpty(filter.businessFunction);
    return {
        search: hasSearch(filter) ? filter.search : null,
        businessFunctions: picks.length > 0 ? picks : null,
        status: filter.status === '' ? null : filter.status,
    };
};

/** True when the user has narrowed the list, so an empty page means "no match" rather than "no contacts". */
export const isNarrowed = (filter: BusinessContactFilterValue): boolean =>
    hasSearch(filter) || filter.businessFunction !== '' || filter.status !== '';
